import { App } from "vue";

export default function install(app: App) {
  // auto focus
  app.directive("focus", {
    mounted(el) {
      el.focus();
    },
  });

  // type="text"에서 숫자만 입력합니다.
  app.directive("onlyNumber", {
    beforeMount(el: any, binding: any, vnode: any) {
      el.addEventListener("input", () => {
        el.value = el.value?.replace(/[^0-9]/g, "");
      });
    },
  });
}
